import { render, staticRenderFns } from "./TillCheckersQueueInfoModal.vue?vue&type=template&id=2b3e6440&scoped=true&"
import script from "./TillCheckersQueueInfoModal.vue?vue&type=script&lang=js&"
export * from "./TillCheckersQueueInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./TillCheckersQueueInfoModal.vue?vue&type=style&index=0&id=2b3e6440&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3e6440",
  null
  
)

export default component.exports